import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Breadcrumb, Card } from 'antd'

import Wrapper from '@common/decorators/Wrapper';
import CheckPermissions from '@common/decorators/CheckPermissions';
import TabellaAllegati from '../components/TabellaAllegati';


//import '../less/Repertorio.less';

@Wrapper({ route: 'AllegatiRoute', hasSidebar: true, hasHeader: true, hasFooter: true })
@CheckPermissions(['adminPermissions'])
class AllegatiRoute extends Component {

  state = {
    loading: false,
  }

  renderTitle() {
    return 'Allegati richiesta di accreditamento'
  }

  render() {

    return (
      <div>
        <Card
          style={{ marginBottom: '12px', backgroundColor: '#fff' }}
          bordered={false}
          className="shadow">
          <h3 className="sectionTitle">{this.renderTitle()}</h3>
          <p>Lista degli allegati</p>
        </Card>
        <div style={{ padding: '12px' }}>
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/dashboard">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item>Allegati</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <TabellaAllegati ref="listTable" {...this.props} />

      </div>
    );
  }
}

export default AllegatiRoute;
